import { Link } from "react-router-dom";
import ScrollToTop from "../../common/ScrollToTop";
import { Button } from "../../common/Button";
import { NotFoundSection, NotFoundInner, NotFoundCode, NotFoundTitle, NotFoundText, Actions } from "./styles";

const NotFound = () => (
  <>
    <ScrollToTop />
    <NotFoundSection>
      <NotFoundInner>
        <NotFoundCode aria-hidden="true">404</NotFoundCode>
        <NotFoundTitle>Page not found</NotFoundTitle>
        <NotFoundText>
          The page you&apos;re looking for doesn&apos;t exist or may have been moved.
        </NotFoundText>
        <Actions>
          <Link to="/">
            <Button>Go to homepage</Button>
          </Link>
        </Actions>
      </NotFoundInner>
    </NotFoundSection>
  </>
);

export default NotFound;
